/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusEmailVorlageDetailDto } from '../../models/lexplus-email-vorlage-detail-dto';
import { LexplusUpdateEmailVorlageDto } from '../../models/lexplus-update-email-vorlage-dto';

export interface EmailTemplateControllerUpdateV1$Params {
  id: string;
      body: LexplusUpdateEmailVorlageDto
}

export function emailTemplateControllerUpdateV1(http: HttpClient, rootUrl: string, params: EmailTemplateControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusEmailVorlageDetailDto>> {
  const rb = new RequestBuilder(rootUrl, emailTemplateControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusEmailVorlageDetailDto>;
    })
  );
}

emailTemplateControllerUpdateV1.PATH = '/v1/email-templates/{id}';
